import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import ReactTooltip from "react-tooltip";

import { AppWrap, MotionWrap } from "../../wrapper";
import { urlFor } from "../../client";
import "./Skills.scss";

import useSanity from "../../customHooks/useSanity";

const Skills = () => {
	const { experiences, skills } = useSanity();

	

	return (
		<>
			<h2 className="head-text">Skills & Experiences</h2>
			<div className="app__skills-container">
				<motion.div className="app__skills-list">
					{skills
						.slice() // Create a shallow copy of the skills array
						.sort(
							(a, b) =>
								new Date(a._createdAt) -
								new Date(b._createdAt)
						) // Sort the skills based on dateAdded
						.map((skill) => (
							<motion.div
								whileInView={{ opacity: [0, 1] }}
								transition={{ duration: 0.5 }}
								className="app__skills-item app__flex"
								key={skill.name}
							>
								<div
									className="app__flex"
									style={{
										backgroundColor: "whitesmoke",
									}}
								>
									<img
										src={urlFor(skill.icon)}
										alt={skill.name}
									/>
								</div>
								<p className="p-text">{skill.name}</p>
							</motion.div>
						))}
				</motion.div>
				<div className="app__skills-exp">
					{experiences.map(
						({
							jobTitle,
							jobDescription,
							startDate,
							endDate,
							isCurrentWorking,
							companyRef,
						}) => {
							// Convert start and end dates to month and year format
							const startDateFormatted = new Date(
								startDate
							).toLocaleString("default", {
								month: "long",
								year: "numeric",
							});
							const endDateFormatted = isCurrentWorking
								? "Present"
								: new Date(endDate).toLocaleString(
										"default",
										{
											month: "long",
											year: "numeric",
										}
								  );

							// Calculate the duration in months and years
							const start = new Date(startDate);
							const end = isCurrentWorking
								? new Date()
								: new Date(endDate);
							const years =
								end.getFullYear() -
								start.getFullYear();
							const months =
								end.getMonth() - start.getMonth();
							const duration =
								years > 0
									? `${years} ${
											years === 1
												? "Year"
												: "Years"
									  }${
											months > 0
												? ` & ${months} ${
														months === 1
															? "Month"
															: "Months"
												  }`
												: ""
									  }`
									: `${months} ${
											months === 1
												? "Month"
												: "Months"
									  }`;

							return (
								<motion.div
									className="app__skills-exp-item"
									key={startDate}
								>
									<motion.div className="app__skills-exp-works">
										<div
											key={jobTitle}
											className="app__skills-exp-work"
											data-tip
											data-for={
												companyRef.brandTitle
											}
										>
											<h3 className="bold-text">
												{jobTitle}
											</h3>
											<h5 className="p-text">
												at {
													companyRef.brandTitle
												}
											</h5>
											<p className="p-text">
												{jobDescription}
											</p>
										</div>
									</motion.div>
									<div className="app__skills-exp-year">
										<p className="bold-text">
											{startDateFormatted} -{" "}
											{endDateFormatted}{" "}
											{!isCurrentWorking &&
												`(${duration})`}
										</p>
									</div>
								</motion.div>
							);
						}
					)}
				</div>
			</div>
		</>
	);
};

export default AppWrap(
	MotionWrap(Skills, "app__skills"),
	"skills",
	"app__whitebg"
);
